import { useMemo } from "react"
import { useMarketplaceListings } from "./useMarketplaceListings"
import type { Listing } from "../types"
import type { ProductType } from "@repo/loomlock/model-types"

// AI: we'll need to allow this to filter on optional creator
export function useListing(
  productType: ProductType,
  tokenId: string,
  sortBy: keyof Listing,
) {
  const {
    listings: allListings,
    isLoading,
    error,
    refetch,
  } = useMarketplaceListings()

  const listings = useMemo(() => {
    const filtered = allListings.filter(
      (l) => l.productType === productType && l.tokenId === tokenId,
    )
    const active = filtered.filter((l) => l.status === "ACTIVE")
    const sortListings = (listings_: Listing[], sB = sortBy) =>
      listings_.sort((a, b) => Number(a[sB]) - Number(b[sB]))

    const lastExpiryDate = active.length
      ? Math.max(
          ...sortListings(active, "endTimestamp").map((l) =>
            Number(l.endTimestamp),
          ),
        )
      : null

    const totalAvailableQuantity = active.reduce(
      (sum, l) => sum + Number(l.quantity),
      0,
    )
    const smallestPrice = active.length
      ? Math.min(...active.map((l) => Number(l.pricePerToken)))
      : null

    // add here if we need to compute more stuff from the listings
    return {
      active,
      filled: sortListings(filtered.filter((l) => l.status === "FILLED")),
      canceled: sortListings(filtered.filter((l) => l.status === "CANCELED")),
      totalAvailableQuantity,
      lastExpiryDate,
      smallestPrice,
    }
  }, [allListings, productType, tokenId, sortBy])

  return {
    listings,
    lidListing: isLoading,
    error,
    refetch,
  }
}
